import { ForgeChrome } from "./forge/components/ForgeChrome";

/**
 * VisionForge — multi-engine live vision + ask VLM under one Forge Suite shell.
 * Engines plug into the registry; shell never hardcodes MediaPipe / VLM details.
 */
export function App() {
  return (
    <div className="vf-app-shell">
      <ForgeChrome />
    </div>
  );
}
